const logs = {
    title: 'Audit Logs',
    subtitle: 'View log data of authentication events made by your admin and users',
    event: 'Event',
    user: 'User',
    application: 'Application',
    time: 'Time',
    filter_by: 'Filter by',
};
export default logs;
